import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import config from '../../config'
import {Link, LinkIcon, GetStartedInput, AboutBanner} from '../../components'
import container from '../../helpers/container'

import Styles from './Morningstar.css'

@CSSModules(Styles)
export default class Morningstar extends Component {
  constructor(props) {
    super(props)
    this.state = { }
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  render() {
    const title = 'Morningstar'
    const description = 'Get your money out of fossil fuels. Morningstar, Inc. provides data and investment research to Fossil Free Funds.'
    const url = config.domain + '/morningstar'

    // const coalicon = require( '../../../static/images/FFF_website_10_assets_about_industriesicons_coal.png' )
    // const oilgasicon = require( '../../../static/images/FFF_website_10_assets_about_industriesicons_oilgas.png' )
    // const utilityicon = require( '../../../static/images/FFF_website_10_assets_about_industriesicons_utilities.png' )

    const iconCo = require( '../../../static/images/icn-co.svg' )
    const iconOg = require( '../../../static/images/icn-og.svg' )
    const iconUt = require( '../../../static/images/icn-ut.svg' )

    return (
      <div>
        {container.helmet(title, description, url)}

        <div styleName='page'>

          <div styleName='container'>
            <div styleName='container-inner'>
              <div styleName='title'>{title}</div>
            </div>
          </div>

          <div styleName='x-morningstar-wrap'>
            <div styleName='x-morningstar-container'>
              <div styleName='x-morningstar-container-inner'>
                <div styleName='x-morningstar-info-photo'>
                  <div
                    styleName='x-morningstar-photo'
                    title='Morningstar'
                  />
                  <div styleName='x-morningstar-info'>
                    <p>
                      Morningstar, Inc. provides data and investment research
                      to Fossil Free Funds. Morningstar has data on thousands
                      of investment offerings, including U.S. stocks and
                      mutual funds, some of the most common investments held
                      in 401(k)s, 403(b)s, and other retirement plans.
                    </p>
                    <p>
                      We use Morningstar’s Global Equity Classification
                      Structure to map companies to industries, so we can
                      track which ones are involved in fossil fuel operations.
                    </p>
                    <p>
                    <Link
                      to={config.links.morningstar}
                      xstrong
                      title='Morningstar'
                    >
                      Visit Morningstar to learn more<LinkIcon />
                    </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <GetStartedInput />

          <div styleName="bullets-container">
            <div styleName="bullets-container-inner">
              <div styleName='title'>
                Fossil fuel industries
              </div>
              <p>
                The 13 Morningstar industries considered fossil fuel and
                screened by Fossil Free Funds are combined into three overall
                categories: coal, oil/gas, and fossil-fired utilities. The
                industries within these three categories include:
              </p>

              <div styleName='industry-icon-wrap'>
                <img
                  styleName='industry-icon'
                  alt='Coal'
                  src={iconCo}
                />
                <div styleName='industry-icon-label-co'>
                  Coal
                </div>
              </div>

              <p styleName='industry-icon-bullet'>
                <strong>Coking Coal:</strong> Companies that produce coking
                coal.
              </p>

              <p styleName='industry-icon-bullet'>
                <strong>Thermal Coal:</strong> Companies that mine thermal
                coal, which is used for generating energy.
              </p>

              <div styleName='industry-icon-wrap'>
                <img
                  styleName='industry-icon'
                  alt='Oil/gas'
                  src={iconOg}
                />
                <div styleName='industry-icon-label-og'>
                  Oil and gas
                </div>
              </div>

              <p styleName='industry-icon-bullet'>
                <strong>Oil and Gas &mdash; Drilling:</strong> Companies primarily engaged in the
                drilling for petroleum and natural gas.
              </p>
              <p styleName='industry-icon-bullet'>
                <strong>Oil and Gas &mdash; Exploration and Production:</strong> Energy companies
                which are primarily engaged in oil and gas exploration and
                production.
              </p>
              <p styleName='industry-icon-bullet'>
                <strong>Oil and Gas &mdash; Integrated:</strong> Major energy companies engaged in
                the diverse aspects of oil and gas operations, including crude
                oil and gas exploration, production, manufacturing, refining,
                marketing, and transportation.
              </p>
              <p styleName='industry-icon-bullet'>
                <strong>Oil and Gas &mdash; Midstream:</strong> Companies that own and operate
                oilfield pipelines and are involved in the gathering,
                processing, and transportation of natural crude petroleum.
              </p>
              <p styleName='industry-icon-bullet'>
                <strong>Oil and Gas &mdash; Refining and Marketing:</strong> Companies that
                refine, gather, market, and sell petroleum and petroleum
                products.
              </p>
              <p styleName='industry-icon-bullet'>
                <strong>Oil and Gas &mdash; Equipment and Services:</strong> Companies that
                provide oilfield services and equipment for activities such as
                contract drilling and seismic surveys. Also includes equipment
                and tool rental, pumping and processing services, and
                inspection and contracting services.
              </p>

              <div styleName='industry-icon-wrap'>
                <img
                  styleName='industry-icon'
                  alt='Fossil-fired utilities'
                  src={iconUt}
                />
                <div styleName='industry-icon-label-ut'>
                  Fossil-fired utilities
                </div>
              </div>

              <p styleName='industry-icon-bullet'>
                <strong>Utilities &mdash; Independent Power Producers:</strong> Companies that own and operate merchant power generation facilities and sell electricity into retail and wholesale markets.
              </p>
              <p styleName='industry-icon-bullet'>
                <strong>Utilities &mdash; Renewable:</strong> Companies that generate, produce, or transmit electric energy from renewable sources, including hydropower, wind, geothermal, biomass, solar, tidal, and wave. (Despite the name, the Utilities-Renewable industry classification includes companies that distribute gas and/or burn fossil fuel for power generation.)
              </p>
              <p styleName='industry-icon-bullet'>
                <strong>Utilities &mdash; Regulated Electric:</strong> Companies that generate, transmit, or distribute electric energy for sale.
              </p>
              <p styleName='industry-icon-bullet'>
                <strong>Utilities &mdash; Regulated Gas:</strong> Companies that transmit, store, or distribute natural gas.
              </p>
              <p styleName='industry-icon-bullet'>
                <strong>Utilities &mdash; Diversified:</strong> Companies engaged in the regulated generation, transmission, or distribution of electricity and natural gas, merchant power generation facilities, and energy marketing operations.
              </p>
              <p styleName='industry-icon-bullet'>
                We remove any utilities that are engaged in 100% renewable operations, pure transmission, or otherwise don't distribute gas or burn fossil fuels to generate power.
              </p>
            </div>
          </div>

          <div styleName='signup-form-container'>
            <div styleName='signup-form-container-inner'>

              <AboutBanner/>

            </div>
          </div>

        </div>

      </div>
    )
  }
}
